import { Fragment } from 'react';
import styled from 'styled-components';
import { OLAF, GREAT_WHITE } from 'HubStyleTokens/colors';
import HR from 'UIComponents/elements/HR';
import SkeletonContainer from 'conversations-skeleton-state/components/SkeletonContainer';
import SkeletonBox from 'conversations-skeleton-state/components/SkeletonBox';
import { VIEW_SELECTOR_FULL_WIDTH, VIEW_SELECTOR_COLLAPSED_WIDTH, VIEW_SELECTOR_BREAK_POINT } from 'svh-workspace-ui-lib/collapsable-sidebar/public';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadViewHeader = styled.div.withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__ThreadViewHeader",
  componentId: "sc-13el29k-0"
})(["display:flex;align-items:center;height:43px;padding-left:24px;padding-right:30px;margin-top:10px;"]);
const ThreadListItemPlaceholder = styled.div.withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__ThreadListItemPlaceholder",
  componentId: "sc-13el29k-1"
})(["display:flex;align-items:center;min-height:40px;max-height:40px;padding:8px 20px 8px 12px;"]);
const CollapseButton = styled(SkeletonBox).withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__CollapseButton",
  componentId: "sc-13el29k-2"
})(["margin-top:16px;margin-left:auto;margin-right:auto;"]);
const DisplayLocked = styled(SkeletonContainer).withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__DisplayLocked",
  componentId: "sc-13el29k-3"
})(["border-right:1px solid ", ";@media (max-width:", "px){display:none;}"], GREAT_WHITE, VIEW_SELECTOR_BREAK_POINT);
const DisplayCollapsed = styled(SkeletonContainer).withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__DisplayCollapsed",
  componentId: "sc-13el29k-4"
})(["border-right:1px solid ", ";@media (min-width:", "px){display:none;}"], GREAT_WHITE, VIEW_SELECTOR_BREAK_POINT);
const StyledHR = styled(HR).withConfig({
  displayName: "ViewSelectorSidebarSkeletonState__StyledHR",
  componentId: "sc-13el29k-5"
})(["width:auto;background-color:", ";"], GREAT_WHITE);
const ViewSelectorSidebarSkeletonState = () => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(DisplayCollapsed, {
      width: VIEW_SELECTOR_COLLAPSED_WIDTH,
      background: OLAF,
      children: /*#__PURE__*/_jsx(CollapseButton, {
        height: "1.5em",
        width: "1.5em"
      })
    }), /*#__PURE__*/_jsxs(DisplayLocked, {
      width: VIEW_SELECTOR_FULL_WIDTH,
      background: OLAF,
      children: [/*#__PURE__*/_jsx(ThreadViewHeader, {
        children: /*#__PURE__*/_jsx(SkeletonBox, {
          height: "1em",
          width: "100%"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "p-left-3",
        children: [/*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "100%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "90%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "80%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "70%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "60%"
          })
        }), /*#__PURE__*/_jsx(StyledHR, {
          distance: "small",
          className: "m-right-3 display-flex"
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "80%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "100%"
          })
        }), /*#__PURE__*/_jsx(ThreadListItemPlaceholder, {
          children: /*#__PURE__*/_jsx(SkeletonBox, {
            height: "1em",
            width: "60%"
          })
        })]
      })]
    })]
  });
};
ViewSelectorSidebarSkeletonState.displayName = 'ViewSelectorSidebarSkeletonState';
export default ViewSelectorSidebarSkeletonState;